var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 134,
    height: 134,
    viewBox: "0 0 134 134",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_476",
    x: 0,
    y: 0,
    width: 134,
    height: 134,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: 6,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#004869",
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#074673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#79a8cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41a1c8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3107",
    "data-name": "Group 3107",
    transform: "translate(-1035 -5484.109)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1035, 5484.11)",
    filter: "url(#Ellipse_476)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_476-2",
    "data-name": "Ellipse 476",
    cx: 37,
    cy: 37,
    r: 37,
    transform: "translate(33 24)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "phone-call-svgrepo-com",
    transform: "translate(1087.988 5528.164)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2801",
    "data-name": "Path 2801",
    d: "M13.048,21.43c3.051,3.029,6.583,5.923,7.97,4.526,1.985-2,3.207-3.74,7.613-.226s1.041,5.881-.882,7.819c-2.219,2.236-10.53.157-18.769-8.019S-1.4,9.057.821,6.82c1.924-1.938,4.264-5.32,7.81-.939s1.817,5.613-.168,7.614C7.077,14.891,10,18.4,13.048,21.43ZM17.473,6.979a1.962,1.962,0,0,0-1.565.5,1.79,1.79,0,0,0,.007,2.5,1.991,1.991,0,0,0,1,.5,8.133,8.133,0,0,1,4.669,2.395,8.129,8.129,0,0,1,2.395,4.669,1.991,1.991,0,0,0,.5,1,1.791,1.791,0,0,0,2.5.007,1.964,1.964,0,0,0,.5-1.565A12.114,12.114,0,0,0,17.473,6.979Zm8.635,1.374c3.339,3.339,4.762,7.128,4.3,10.2a2.009,2.009,0,0,0,.473,1.607,1.786,1.786,0,0,0,2.517.005,2.227,2.227,0,0,0,.524-1.13c.383-2.653-.1-7.991-5.3-13.192S18.08.159,15.426.541a2.224,2.224,0,0,0-1.13.524A1.785,1.785,0,0,0,14.3,3.581a2.009,2.009,0,0,0,1.607.473C18.98,3.591,22.769,5.015,26.107,8.353Z",
    transform: "translate(0 -0.44)",
    fill: "url(#linear-gradient)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactus);
export default __webpack_public_path__ + "static/media/contactus.4c62ca2d8b57882f66ce4d71e62d4a85.svg";
export { ForwardRef as ReactComponent };